import { useEffect, useMemo, useState } from "react";
import { NumericFormat } from "react-number-format";
import { ThemedSpan } from "../../../components/utilities";
import CashSourceRow from "./CashSourceRow";
import InstructionLabelRow from "./InstructionLabelRow";

const TransferOutCash = ({ data, updateFn, setTotalCashRaised }) => {

    const totalCashTransferred = useMemo(() => data.preTransferSalesAmount + data.existingCashBalanceAmount, [data.existingCashBalanceAmount, data.preTransferSalesAmount]);

    const remainingBalance = useMemo(() => data.preTransferSalesAmount + data.existingCashBalanceAmount, [data.existingCashBalanceAmount, data.preTransferSalesAmount]);

    const [initialTotalCashValue, setInitialTotalCashValue] = useState(totalCashTransferred);

    useEffect(() => {
        setTotalCashRaised(totalCashTransferred);
    }, [totalCashTransferred, setTotalCashRaised]);

    useEffect(() => {
        if (totalCashTransferred === initialTotalCashValue) return;

        setInitialTotalCashValue(totalCashTransferred);
    }, [initialTotalCashValue, totalCashTransferred]);

    return <>
        <div className="container-fluid mb-4">
            <CashSourceRow
                label={"Existing Cash Balance"}
                data={data}
                updateFn={updateFn}
                appliesProperty={"existingCashBalanceApplies"}
                commentProperty={"existingCashBalanceComment"}
                cashAmountProperty={"existingCashBalanceAmount"}
                receivedDateProperty={"existingCashBalanceReceivedDate"}
                receivedConfirmedByNameProperty={"existingCashBalanceReceivedConfirmedByName"}
                receivedConfirmedSetDateProperty={"existingCashBalanceReceivedConfirmedSetDate"}
            />

            <CashSourceRow
                label="Pre-transfer Sales"
                data={data}
                updateFn={updateFn}
                appliesProperty={"preTransferSalesApplies"}
                commentProperty={"preTransferSalesComment"}
                cashAmountProperty={"preTransferSalesAmount"}
                receivedDateProperty={"preTransferSalesReceivedDate"}
                receivedConfirmedByNameProperty={"preTransferSalesReceivedConfirmedByName"}
                receivedConfirmedSetDateProperty={"preTransferSalesReceivedConfirmedSetDate"}
            />

            <div className="row my-2">
                <div className="col-2">
                    <b><ThemedSpan>Total Cash Transferred</ThemedSpan></b>
                </div>
                <div className="col-2 text-end">
                    <b><NumericFormat value={totalCashTransferred} prefix={"£"} thousandSeparator displayType="text" decimalScale={2} fixedDecimalScale /></b>
                </div>
            </div>
        </div>
    </>
}

export default TransferOutCash;